import React, { ChangeEvent, FocusEvent, KeyboardEvent } from "react";
import { InputStyled } from "./styled";

interface InputProps {
  type: string;
  height: number;
  width: string;
  fontSize?: string;
  background?: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const Input: React.ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  {
    type,
    height,
    width,
    fontSize,
    background,
    value,
    onChange,
    placeholder,
    onBlur,
    onKeyDown,
  },
  ref
) => {
  return (
    <InputStyled
      type={type}
      height={height}
      width={width}
      fontSize={fontSize}
      background={background}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      ref={ref}
    />
  );
};

export default React.forwardRef(Input);
